export const TIPS_CONTENT = 'TransGPT 模型旨在提升技术领域的研究和应用效率，我们鼓励和欢迎开发者及社区成员共同遵守相关开源协议，确保技术的正当和安全使用。请广大用户注意，不得将此模型及其衍生代码用于任何可能对国家安全和社会稳定造成威胁的活动，以及未经过严格安全评估和官方备案的服务。\n' +
    '\n' +
    'TransGPT 模型在设计和训练过程中尽量保证数据的合规性和准确性，但由于其复杂性和概率性的特点，我们无法完全保证输出内容的百分百准确无误。此外，模型输出结果可能受到用户输入内容的影响而产生偏差。因此，我们不对由于使用本模型而引起的任何数据安全问题、舆论风险、误导信息的传播或任何形式的不当使用承担责任。\n' +
    '\n' +
    '您不得利用本服务自行或者帮助他人上传、诱导生成、传播以下信息内容：\n' +
    '（1）破坏国家统一和社会稳定、危害国家政权和社会主义制度；\n' +
    '（2）违反国家规定的政治宣传和新闻信息；\n' +
    '（3）涉及国家安全和国防利益的信息；\n' +
    '（4）危害国家安全和利益、损害国家形象；\n' +
    '（5）封建迷信和暴力、淫秽、色情信息；\n' +
    '（6）涉及博彩、赌博、作弊等非法互联网活动的相关信息；\n' +
    '（7）违反国家民族和宗教政策的信息；\n' +
    '（8）妨碍互联网运行安全的信息；\n' +
    '（9）侵害他人合法权益的信息和其他有损于社会秩序、公共道德的信息；\n' +
    '（10）传播虚假有害信息；\n' +
    '（11）包括但不限于针对信仰、地域、性别、年龄、职业、残疾人等方面的歧视性内容；\n' +
    '（12）其他违反法律、法规、部门规章或国家政策的信息。';
